export class Case {
    constructor() {
        $("#system-message-container")
            .on("click", "#system-message-save", this.clickSave)
            .on("click", "#system-message-activate", this.clickActivate)
            .on("click", "#system-message-deactivate", this.clickDeactivate);
    }

    clickSave = (event: JQuery.ClickEvent) => {
        let ok = confirm("Really want to save system message?");
        if (!ok) {
            return
        }

        $("#system-message-form").trigger("submit");
    }

    clickActivate = (event: JQuery.ClickEvent) => {
        let ok = confirm("Really want to activate system message?");
        if (!ok) {
            return
        }

        $("#system-message-status").val("true");
        $("#system-message-form").trigger("submit");
    }

    clickDeactivate = (event: JQuery.ClickEvent) => {
        let ok = confirm("Really want to deactivate system message?");
        if (!ok) {
            return
        }

        $("#system-message-status").val("false");
        $("#system-message-form").trigger("submit");
    }
}
